import { atom } from "jotai";
import {
  emitEventOnStartingOverSetter,
  zslExecutionFailedErrorMsgAtom,
  showAIStreamCreateModalAtom,
  togglesAtom,
  isAiPageAtom,
  createNewCanvasSetter,
} from "@zapier/canvas-state";

import { aiPromptAtomResettable } from "./aiPromptAtom";
import { showWelcomeModalAtom } from "./showWelcomeModalAtom";
import { outlineAtom } from "./outlineAtom";

export const startOverSetter = atom(
  null, // Read function (no value needed)
  // Write function (this is the actual start over implementation now)
  async (get, set) => {
    const isAiPage = get(isAiPageAtom);

    if (isAiPage) {
      await set(emitEventOnStartingOverSetter);
      setTimeout(() => {
        set(createNewCanvasSetter, {
          nodes: [],
          edges: [],
          options: { skipBeforeUnloadCheck: true },
        });
      }, 0);
      return;
    }

    // Logic for non-AI page start over
    set(showAIStreamCreateModalAtom, false);
    set(showWelcomeModalAtom, true);
    set(aiPromptAtomResettable, "");

    const toggles = get(togglesAtom);
    if (!toggles.streamingUi) {
      set(outlineAtom, "");
    }
    set(zslExecutionFailedErrorMsgAtom, null); // Clear out old error alert
    await set(emitEventOnStartingOverSetter);
  },
);

startOverSetter.debugLabel = "startOverSetter";
